// app/javascript/controllers/add_to_calendar_controller.js
import { Controller } from "@hotwired/stimulus";
import * as calendar from "calendar-link";

// Connects to data-controller="add-to-calendar"
export default class extends Controller {
  static values = {
    description: String,
    end: String,
    location: String,
    repeatDays: { type: Number, default: 0 },
    start: String,
    title: String,
    url: String,
  };

  static targets = ["service", "modal"];
  static classes = ["open", "closed"];

  serviceTargetConnected(target) {
    const service = target.dataset.service;
    if (!calendar[service]) {
      console.warn(`Unsupported calendar service: ${service}`);
      target.remove();
      return;
    }
    const event = {
      description: this.descriptionValue,
      end: this.endValue,
      location: this.locationValue,
      rRule: this.calculateRRule(),
      start: this.startValue,
      title: this.titleValue,
      url: this.urlValue,
    };
    target.href = calendar[service](event);
  }

  calculateRRule() {
    const days = this.repeatDaysValue;
    if (days <= 1) return null;
    return `FREQ=DAILY;COUNT=${days}`;
  }

  toggleModal(show) {
    const { openClasses, closedClasses } = this;
    if (show) {
      this.modalTarget.classList.add(...openClasses);
      this.modalTarget.classList.remove(...closedClasses);
    } else {
      this.modalTarget.classList.remove(...openClasses);
      this.modalTarget.classList.add(...closedClasses);
    }
  }

  openModal() {
    this.toggleModal(true);
  }

  closeModal() {
    this.toggleModal(false);
  }

  open(event) {
    event.preventDefault();
    this.openModal();
  }

  // clicking a service link. The anchor element will handle navigation
  openService() {
    this.closeModal();
  }
}
